<template>
  <div>
    <h1 class="mb-2 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('mahasiswa')">
        Mahasiswa
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ mahasiswa.name }}
    </h1>
    <span class="mb-6 font-semibold text-xl">Status: {{ verificationStatus }}</span>
    <tab-view
      :step="lastInputStep"
      :open-tab="currentTab"
      @tab-changed="onTabChanged">
      <template #tab1>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            :value="mahasiswa.name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Lengkap"
            disabled />
          <text-input
            :value="mahasiswa.pob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tempat Lahir"
            disabled />
          <text-input
            v-mask="'##/##/####'"
            :value="mahasiswa.dob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tanggal Lahir"
            placeholder="dd/mm/yyyy"
            disabled />
          <text-input
            :value="mahasiswa.gender"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Jenis Kelamin"
            disabled />
          <text-input
            :value="mahasiswa.nik"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No KTP"
            disabled />
          <text-input
            :value="mahasiswa.no_kk"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nomor Kartu Keluarga"
            disabled />
          <text-input
            :value="mahasiswa.nim"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nomor Induk Mahasiswa"
            disabled />
          <text-input
            :value="mahasiswa.phone_number"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Handphone"
            disabled />
          <text-input
            :value="mahasiswa.phone_number_wa"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Whatsapp"
            disabled />
          <text-input
            :value="mahasiswa.email"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="Email Mahasiswa"
            disabled />
          <text-area-input
            :value="mahasiswa.address_origin"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Alamat Asal mahasiswa/i di kab.puncak"
            disabled />
          <text-input
            :value="mahasiswa.distrik_name"
            class="pr-6 pb-8 w-1/2 lg:w-1/4"
            label="Nama Distrik"
            disabled />

          <div class="w-full" />

          <text-input
            :value="mahasiswa.distrik_head_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Kepala Distrik"
            disabled />
          <text-input
            :value="mahasiswa.kampung_head_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Kepala Kampung"
            disabled />
          <text-area-input
            :value="mahasiswa.address_current"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Alamat Domisili mahasiswa/i saat ini"
            disabled />

          <div class="w-full" />

          <text-input
            :value="mahasiswa.shs_name"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nama SMA/SMU/SMK"
            disabled />
          <text-area-input
            :value="mahasiswa.shs_address"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Alamat SMA/SMU/SMK"
            disabled />
          <text-input
            :value="mahasiswa.shs_phone_number"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No. Telp SMA/SMU/SMK"
            disabled />

          <div class="w-full" />

          <text-input
            :value="mahasiswa.bank_acc_number"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Rekening Mahasiswa"
            disabled />
          <text-input
            :value="mahasiswa.bank_acc_name"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nama Pemilik Rekening"
            disabled />
          <text-input
            :value="mahasiswa.bank_name"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nama Bank"
            disabled />
        </div>
      </template>
      <template #tab2>
        <div
          class="invisible lg:visible border-2-2 absolute border-opacity-20 border-gray-700 h-full -my-5 border"
          style="left: 50%" />
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input
            :value="mahasiswa.is_father_alive"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Status Ayah"
            disabled>
            <option :value="1">
              MASIH HIDUP
            </option>
            <option :value="0">
              SUDAH MENINGGAL
            </option>
          </select-input>
          <text-input
            :value="mahasiswa.father_nik"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No KTP Ayah"
            disabled />
          <select-input
            :value="mahasiswa.is_mother_alive"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Status Ibu"
            disabled>
            <option :value="1">
              MASIH HIDUP
            </option>
            <option :value="0">
              SUDAH MENINGGAL
            </option>
          </select-input>
          <text-input
            :value="mahasiswa.mother_nik"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No KTP Ibu"
            disabled />
          <text-input
            :value="mahasiswa.father_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Lengkap Ayah"
            disabled />
          <text-input
            :value="mahasiswa.mother_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Lengkap Ibu"
            disabled />
          <text-input
            :value="mahasiswa.father_pob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tempat Lahir Ayah"
            disabled />
          <text-input
            v-mask="'##/##/####'"
            :value="mahasiswa.father_dob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tanggal Lahir Ayah"
            placeholder="dd/mm/yyyy"
            disabled />
          <text-input
            :value="mahasiswa.mother_pob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tempat Lahir Ibu"
            disabled />
          <text-input
            v-mask="'##/##/####'"
            :value="mahasiswa.mother_dob"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Tanggal Lahir Ibu"
            placeholder="dd/mm/yyyy"
            disabled />
          <text-area-input
            :value="mahasiswa.father_address_current"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Alamat Ayah (sesuai KTP)"
            disabled />
          <text-area-input
            :value="mahasiswa.father_address_origin"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Alamat Lengkap Asal Ayah"
            disabled />
          <text-area-input
            :value="mahasiswa.mother_address_current"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Alamat Ibu (sesuai KTP)"
            disabled />
          <text-area-input
            :value="mahasiswa.mother_address_origin"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Alamat Lengkap Asal Ibu"
            disabled />
          <text-input
            :value="mahasiswa.father_phone_number"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Telp Ayah"
            disabled />
          <text-input
            :value="mahasiswa.father_job"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Pekerjaan Ayah"
            disabled />
          <text-input
            :value="mahasiswa.mother_phone_number"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Telp Ibu"
            disabled />
          <text-input
            :value="mahasiswa.mother_job"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Pekerjaan Ibu"
            disabled />
        </div>
      </template>
      <template #tab3>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            :value="mahasiswa.university_name"
            class="pr-6 pb-8 w-full lg:w-3/6"
            label="Nama Universitas"
            disabled />
          <text-input
            :value="mahasiswa.university_accreditation"
            class="pr-6 pb-8 w-full lg:w-1/6"
            label="Akreditasi"
            disabled />
          <text-area-input
            :value="mahasiswa.university_address"
            class="pr-6 pb-8 w-full lg:w-2/6"
            label="Alamat Kampus"
            disabled />
          <text-input
            :value="mahasiswa.university_email"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Email Universitas"
            disabled />
          <text-input
            :value="mahasiswa.university_phone"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No. Telp Universitas"
            disabled />
          <text-input
            :value="mahasiswa.university_rector_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Lengkap Rektor/Ketua/Direktur"
            disabled />
          <text-input
            :value="mahasiswa.prodi_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Prodi"
            placeholder="Ketikkan nama prodi tanpa disingkat"
            disabled />
          <text-input
            :value="mahasiswa.prodi_head_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama Lengkap Kepala Program Studi/Jurusan"
            disabled />
          <text-input
            :value="mahasiswa.prodi_staff_name"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Nama Staff Bagian Kemahasiswaan"
            disabled />
          <text-input
            :value="mahasiswa.prodi_staff_phone"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Telepon Bagian Kemahasiswaan"
            disabled />
          <text-input
            :value="mahasiswa.prodi_staff_mobile"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Handphone Bagian Kemahasiswaan"
            disabled />
          <text-input
            :value="mahasiswa.prodi_staff_wa"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="No Whatsapp Bagian Kemahasiswaan"
            disabled />
          <text-input
            :value="mahasiswa.ref_jenjang_pendidikan_name"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Jenjang Pendidikan"
            disabled />
          <text-input
            :value="mahasiswa.college_entry_year"
            class="pr-6 pb-8 w-full lg:w-1/5"
            label="Tahun Masuk Kuliah"
            disabled />
          <text-input
            :value="mahasiswa.current_semester"
            class="pr-6 pb-8 w-full lg:w-1/5"
            label="Semester"
            disabled />
          <text-input
            :value="mahasiswa.current_gpa"
            class="pr-6 pb-8 w-full lg:w-1/5"
            label="IPK"
            placeholder="0.00 - 4.00"
            disabled />
          <text-input
            :value="mahasiswa.scholarship_bank_acc_number"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="No Rekening Bank (Kampus)"
            disabled />
          <text-input
            :value="mahasiswa.scholarship_bank_acc_name"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="Nama Pemilik Rekening (Kampus)"
            disabled />
          <text-input
            :value="mahasiswa.scholarship_bank_name"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="Nama Bank (Kampus)"
            disabled />
        </div>
      </template>
      <template #tab4>
        <table class="table-fixed">
          <thead>
            <tr>
              <th class="w-1/4 px-4 py-2 text-light-blue-600">
                Jenis Berkas
              </th>
              <th class="w-1/4 px-4 py-2 text-light-blue-600">
                Data Form
              </th>
              <th class="w-1/4 px-4 py-2 text-light-blue-600">
                Status Approval
              </th>
              <th class="w-1/2 px-4 py-2 text-light-blue-600">
                Deskripsi
              </th>
              <th class="w-1/4 px-4 py-2 text-light-blue-600">
                Preview
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                KTP Mahasiswa
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.nik }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.nik_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.nik_file_reason"
                  :error="form.errors.nik_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.nik_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="previewFile('nik_file')">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                KK Mahasiswa
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.no_kk }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.no_kk_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.no_kk_file_reason"
                  :error="form.errors.no_kk_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.no_kk_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="previewFile('no_kk_file')">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td
                class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium"
                colspan="2">
                Pasfoto Mahasiswa (Berwarna, Ukuran 4x6)
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.photo_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.photo_reason"
                  :error="form.errors.photo_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.photo"
                  class="btn-green"
                  type="button"
                  @click.prevent="previewFile('photo')">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                KTP Ayah
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.father_nik }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.father_nik_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.father_nik_file_reason"
                  :error="form.errors.father_nik_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.father_nik_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile('father_nik_file')
                  ">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                KTP Ibu
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.mother_nik }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.mother_nik_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.mother_nik_file_reason"
                  :error="form.errors.mother_nik_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.mother_nik_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile('mother_nik_file')
                  ">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                Scan buku rekening Mahasiswa
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.bank_acc_number }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.bank_acc_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.bank_acc_file_reason"
                  :error="form.errors.bank_acc_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.bank_acc_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile('bank_acc_file')
                  ">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td
                class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium"
                colspan="2">
                Scan dokumen surat pernyataan
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.statement_doc_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.statement_doc_file_reason"
                  :error="form.errors.statement_doc_file_reason
                  "
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.statement_doc_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile('statement_doc_file')
                  ">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                KTM Mahasiswa
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium" disabled>
                {{ mahasiswa.nim }}
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select v-model="form.student_id_file_verified" class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.student_id_file_reason"
                  :error="form.errors.student_id_file_reason"
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.student_id_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile('student_id_file')
                  ">
                  Preview
                </button>
              </td>
            </tr>
            <tr>
              <td
                class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium"
                colspan="2">
                Surat Rekomendasi Ikatan Mahasiswa
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <select
                  v-model="form.recommendation_letter_file_verified
                  "
                  class="form-select">
                  <option :value="null">
                    SEDANG DIVERIFIKASI
                  </option>
                  <option :value="1">
                    DITERIMA
                  </option>
                  <option :value="0">
                    DITOLAK
                  </option>
                </select>
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <text-area-input
                  v-model="form.recommendation_letter_file_reason
                  "
                  :error="form.errors
                    .recommendation_letter_file_reason
                  "
                  class="w-full" />
              </td>
              <td class="border border-light-blue-500 px-4 py-2 text-light-blue-600 font-medium">
                <button
                  v-if="mahasiswa.recommendation_letter_file"
                  class="btn-green"
                  type="button"
                  @click.prevent="
                    previewFile(
                      'recommendation_letter_file'
                    )
                  ">
                  Preview
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </tab-view>
    <div class="py-4 mx-2 bg-gray-50 border-t border-gray-100 flex justify-end">
      <div class="mx-4 my-2">
        <label class="text-lg font-bold">Status Pengajuan Beasiswa</label>
      </div>
      <div class="mr-2">
        <select
          v-model="form.ref_verification_status_id"
          class="form-select"
          required>
          <option :value="1">
            Menunggu kelengkapan data
          </option>
          <option :value="2">
            Menunggu proses verifikasi
          </option>
          <option :value="3">
            Memenuhi syarat
          </option>
          <option :value="4">
            Tidak memenuhi syarat
          </option>
        </select>
      </div>
      <div class="mr-2">
        <form @submit.prevent="update">
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Simpan Perubahan
          </loading-button>
        </form>
      </div>
    </div>
    <verification-modal
      :is-modal-visible="isModalVisible"
      :img-url="imgUrl"
      :mahasiswa="mahasiswa"
      :field-name="selectedFileField"
      @close="closeModal" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TabView from '@/Shared/TabView'
import VerificationModal from '@/Shared/VerificationModal'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo () {
        return {
            title: `Verifikasi Mahasiswa - ${this.mahasiswa.name}`,
        }
    },
    components: {
        LoadingButton,
        SelectInput,
        TextInput,
        TabView,
        TextAreaInput,
        VerificationModal,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        mahasiswa: Object,
        verificationStatus: String,
    },
    data () {
        return {
            form: useForm({
                id: this.mahasiswa.id,
                nik_file_verified: this.mahasiswa.nik_file_verified,
                nik_file_reason: this.mahasiswa.nik_file_reason,
                no_kk_file_verified: this.mahasiswa.no_kk_file_verified,
                no_kk_file_reason: this.mahasiswa.no_kk_file_reason,
                photo_verified: this.mahasiswa.photo_verified,
                photo_reason: this.mahasiswa.photo_reason,
                father_nik_file_verified:
                    this.mahasiswa.father_nik_file_verified,
                father_nik_file_reason: this.mahasiswa.father_nik_file_reason,
                mother_nik_file_verified:
                    this.mahasiswa.mother_nik_file_verified,
                mother_nik_file_reason: this.mahasiswa.mother_nik_file_reason,
                bank_acc_file_verified: this.mahasiswa.bank_acc_file_verified,
                bank_acc_file_reason: this.mahasiswa.bank_acc_file_reason,
                statement_doc_file_verified:
                    this.mahasiswa.statement_doc_file_verified,
                statement_doc_file_reason:
                    this.mahasiswa.statement_doc_file_reason,
                student_id_file_verified:
                    this.mahasiswa.student_id_file_verified,
                student_id_file_reason: this.mahasiswa.student_id_file_reason,
                ref_scholarship_acc_verified:
                    this.mahasiswa.ref_scholarship_acc_verified,
                ref_verification_status_id:
                    this.mahasiswa.ref_verification_status_id,
                recommendation_letter_file_verified:
                    this.mahasiswa.recommendation_letter_file_verified,
                recommendation_letter_file_reason:
                    this.mahasiswa.recommendation_letter_file_reason,
            }),
            is_readonly: true,
            imgUrl: null,
            isModalVisible: false,
            currentTab: 1,
            lastInputStep: 4,
            selectedFileField: null,
        }
    },
    methods: {
        onTabChanged (val) {
            this.currentTab = val
        },
        closeModal () {
            this.isModalVisible = false
        },
        previewFile (fieldName) {
            this.selectedFileField = fieldName
            this.isModalVisible = true
            this.imgUrl = `/mahasiswa/${this.mahasiswa.id}/file?doc_type=${fieldName}`
        },
        update () {
            this.form.put(this.route('mahasiswa.verify.update', this.mahasiswa.id))
        },
    },
}
</script>
